import {yupResolver} from "@hookform/resolvers/yup";
import {Grid} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {AxiosError} from "axios";
import _ from "lodash";
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useHistory} from "react-router";
import {useLocation, useNavigate} from "react-router-dom";
import {chargePayer} from "src/api/chargePayer";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import {getChannels, IChannelsResponseItem} from "src/api/getChannels";
import {getDataInitPayment, postInitPayment} from "src/api/initPayment";
import {deleteTokenCardById, getTokenCardByAccountId} from "src/api/tokenCard";
import {colors} from "src/colors/colors";
import ButtonCommon from "src/commonStyles/button/button";
import ContainerContent from "src/commonStyles/container/containerContent/containerContent";
import HeaderTitle from "src/commonStyles/text/headerTitle/headerTitle";
import SesstionTitle from "src/commonStyles/text/sessionTitile/sessionTitle";
import ControllerRadio from "src/components/Form/ControllerRadio";
import ControllerTextField from "src/components/Form/ControllerTextField";
import StepsPayment from "src/components/homePage/components/steps/steps";
import {PaymentResultSuccess} from "src/const";
import {CALLBACK_URL, FR_HEADER, FR_SYSTEM_CONFIG} from "src/const/const-from-env";
import {VALIDATE_MESSAGE} from "src/const/message";
import {partnerCode} from "src/const/partnerCode";
import useCheckMobile from "src/hook/useCheckMobile";
import {IRequestInitPayment} from "src/interface/typePay";
import i18n from "src/lang/i18n";
import {useCheckLoading} from "src/providers/checkLoadingProvider";
import PopupService from "src/utils/PopupService";
import * as yup from "yup";
import CardToken from "./components/cardToken";
import QrPayContent from "../QrPay/QrPayContent";

const useStyle = makeStyles((theme) => {
  return {
    container: {
      paddingBottom: "24px",
      [theme.breakpoints.down("md")]: {
        paddingBottom: "8px",
      },
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      paddingBottom: "2rem",
      paddingTop: "4rem",
      [theme.breakpoints.down("md")]: {
        paddingBottom: 0,
        paddingTop: "2rem",
      },
    },
    imageType: {
      paddingLeft: "10px",
      height: "3rem",
      objectFit: "cover",
    },
    itemContainer: {
      width: "100%",
      textAlign: "center",
    },
    typePaymentText: {
      fontWeight: 600,
      [theme.breakpoints.down("md")]: {
        fontWeight: 700,
      },
    },
    containerContent: {},
  };
});

interface IForm {
  type: string;
  tokenId: number;
  typePay: string;
  cardTokenId: number | null;
  name: string | null;
  email: string | null;
  phone: string | number | null;
  user_email: string | null;
}

interface IParamsPage {
  frSystm: string;
  paymentId: string;
  type?: string;
}

export const handleBackApp = (type: string, data?: any) => {
  if (window?.ReactNativeWebView) {
    window?.ReactNativeWebView?.postMessage(
      JSON.stringify({
        type,
        data
      })
    );
  }
  if (window?.flutter_inappwebview) {
    window?.flutter_inappwebview?.callHandler(
      'ReactNativeWebView',
      JSON.stringify({
        type,
        data
      })
    )
  }
}


const TypePay = (props) => {
  const history = useHistory();
  const classes = useStyle();
  const isMobile = useCheckMobile();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  const {setIsLoading} = useCheckLoading();
  const [disabledButton, setDisabledButton] = useState(false);
  const [dataToSend, setDataToSend] = useState<IRequestInitPayment | null>({
    ...state,
    callbackUrl: CALLBACK_URL,
  });
  const [userEmail, setUserEmail] = useState<string>("");
  const [dataRequestInitPayment, setDataRequestInitPayment] = useState<any>();
  const [dataCardToken, setDataCardToken] = useState<any[] | null>();
  const [showCardSaved, setShowCardSaved] = useState<boolean>(false);
  const [userInfo, setUserInfo] = useState<any>();
  const [tokenSelected, setTokenSeleted] = useState<any>();

  const search = location.search;
  const searchParams = new URLSearchParams(search.substring(1));
  const entries = searchParams.entries();
  const params = paramsToObject(entries) as IParamsPage;
  const [openQrPayDialog, setOpenQrPayDialog] = useState(false);

  const handleClickOpen = () => {
    setOpenQrPayDialog(true);
  };

  const handleClose = () => {
    setOpenQrPayDialog(false);
  };

  function paramsToObject(entries) {
    const result = {};
    for (const [key, value] of entries) {
      // each 'entry' is a [key, value] tupple
      result[key] = value;
    }
    return result;
  }

  const [options, setOptions] = useState([]);
  const [channels, setChannels] = useState<IChannelsResponseItem[]>([]);

  const validateObj = {
    type: yup.string().required(VALIDATE_MESSAGE.REQUIRED()).default("1"),
    name: yup
      .string()
      .when("type", {
        is: "2",
        then: (schema) => schema.required(VALIDATE_MESSAGE.REQUIRED()),
      })
      .max(100, VALIDATE_MESSAGE.MAXLENGTH("Tên người đóng phí", 100)),
    email: yup
      .string()
      .when("type", {
        is: "2",
        then: (schema) =>
          schema
            .required(VALIDATE_MESSAGE.REQUIRED())
            .email(VALIDATE_MESSAGE.FORMATWRONG("Email")),
      })
      .max(100, VALIDATE_MESSAGE.MAXLENGTH("Email", 100)),
    phone: yup
      .string()
      .when("type", {
        is: "2",
        then: (schema) =>
          schema
            .required(VALIDATE_MESSAGE.REQUIRED()),
      })
      .test(
        "phone",
        VALIDATE_MESSAGE.MAXLENGTH("Số điện thoại người đóng phí", 10),
        (value) => `${value}`?.length <= 10
      ),
    typePay: yup.string().default("QRGEN"),
  }

  const validationSchema = yup.object().shape(!userEmail ? {
    ...validateObj,
    user_email: yup
      .string()
      .when("type", {
        is: "1",
        then: (schema) =>
          schema
            .required(VALIDATE_MESSAGE.REQUIRED())
            .email(VALIDATE_MESSAGE.FORMATWRONG("Email")),
      })
      .max(100, VALIDATE_MESSAGE.MAXLENGTH("Email", 100))
  } : {...validateObj});

  const {control, handleSubmit, reset, formState, watch, setValue, register} =
    useForm<IForm>({
      mode: "all",
      resolver: yupResolver(validationSchema),
      defaultValues: validationSchema.getDefault(),
    });

  const onSubmit = (data: IForm) => {
    onCreateInitPayment(data);
  };
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await getChannels(
        !_.isEmpty(params) ? params.frSystm : FR_HEADER
      );


      setChannels(res.data?.data);
      localStorage.setItem("channels", JSON.stringify(res.data?.data));
      const dataListRaw = res.data?.data;
      const list = [];
      if (!_.isEmpty(dataListRaw)) {

        if (
          dataListRaw?.find((item) => item.partner.partnerCode === "QRGEN")
        ) {
          list.push(
            dataListRaw?.find((item) => item.partner.partnerCode === "QRGEN")
          );
        }
        if (
          dataListRaw?.find((item) => item.partner.partnerCode === "baokim")
        ) {
          list.push(
            dataListRaw?.find((item) => item.partner.partnerCode === "baokim")
          );
        }
        if (
          dataListRaw?.find((item) => item.partner.partnerCode === "MBECOM")
        ) {
          list.push(
            dataListRaw?.find((item) => item.partner.partnerCode === "MBECOM")
          );
        }
        if (
          dataListRaw?.find((item) => item.partner.partnerCode === "UNLIMINT")
        ) {
          list.push(
            dataListRaw?.find((item) => item.partner.partnerCode === "UNLIMINT")
          );
        }
        if (dataListRaw?.find((item) => item.partner.partnerCode === "momo")) {
          list.push(
            dataListRaw?.find((item) => item.partner.partnerCode === "momo")
          );
        }
      }
      const otherList = dataListRaw?.filter(
        (item) =>
          item.partner.partnerCode !== "MBECOM" &&
          item.partner.partnerCode !== "UNLIMINT" &&
          item.partner.partnerCode !== "QRGEN" &&
          item.partner.partnerCode !== "baokim" &&
          item.partner.partnerCode !== "momo"
      );
      const result = [...otherList, ...list];
      const listPayType = result?.map((item) => {
        return {
          value: item?.partner?.partnerCode,
          label: (
            <div className={classes.itemContainer}>
              <div className={classes.typePaymentText}>
                {item.partner.partnerName}
              </div>
            </div>
          ),
          positionSubContent: "right",
          subContent: (
            <img className={classes.imageType} src={item.partner.logo}/>
          ),
        };
      });

      setOptions(listPayType);
    } catch (e) {
      const err = e as AxiosError;
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
    if (params?.paymentId) {
      localStorage.setItem("urlTypePay", window.location.href);
      localStorage.setItem("paymentId", params?.paymentId);
      localStorage.setItem("frSystm", params?.frSystm);
      setIsLoading(true);
      try {
        const res = await getDataInitPayment(params?.paymentId);
        const sts = res.data?.msgSts;
        const data = res?.data?.data;

        const typePayment = data?.policy?.feeType;
        const callBackUrl = CALLBACK_URL + (params?.frSystm ? params?.type ? `?frSystm=${params?.frSystm}&type=${params?.type}` : `?frSystm=${params?.frSystm}` : '');
        setUserEmail(data?.policy?.userInfo?.email);
        setDataRequestInitPayment(data);
        setUserInfo(data?.policy?.userInfo);
        ///Call get token card
        if (data?.policy?.userInfo?.accountId) {

          fetchDataCardToken(data?.policy?.userInfo?.accountId);
        }

        if (
          sts.code == "001" ||
          localStorage.getItem("paymentResult") === PaymentResultSuccess &&
          localStorage.getItem("paymentedId") === params?.paymentId
        ) {
          PopupService.instance.current.open({
            visible: true,
            content: sts?.message,
            onOk: () => {
              PopupService.instance.current.close();
              navigate("/");
            },
          });
          setDisabledButton(true);
        }
        localStorage.setItem(
          "callbackURL",
          res?.data?.data?.policy?.callbackURL
        );
        switch (typePayment) {
          case "P001":
            setDataToSend({
              policy: {
                feeType: data?.policy?.feeType,
                idNumber: data?.policy?.idNumber,
                prdName: data?.policy?.prdName,
                productCode: data?.policy?.productCode,
                phName: data?.policy?.phName,
                ccAllow: data?.policy?.ccAllow,
                orderId: `${data?.policy?.idNumber}_${params?.frSystm}_${data?.policy?.feeType
                }_${new Date().getTime()}`,
                payId: params?.paymentId,
                initialPremium: data.policy.initialPremium,
              },
              callbackUrl: callBackUrl,
              savePaymentMethod: data?.policy?.savePaymentMethod,
              clientType: data?.policy?.clientType,
              description: data?.policy?.description,
              userInfo: {
                accountId: data?.policy?.userInfo?.accountId,
                tokenId: data?.policy?.userInfo.tokenId,
                email: data?.policy?.userInfo.email,
              },
            });
            break;
          case "P002":
            setDataToSend({
              policy: {
                feeType: data?.policy?.feeType,
                idNumber: data?.policy?.idNumber,
                prdName: data?.policy?.prdName,
                productCode: data?.policy?.productCode,
                phName: data?.policy?.phName,
                ccAllow: data?.policy?.ccAllow,
                orderId: `${data?.policy?.idNumber}_${params?.frSystm}_${data?.policy?.feeType
                }_${new Date().getTime()}`,
                payId: params?.paymentId,
                duePremium: data?.policy?.duePremium,
              },
              callbackUrl: callBackUrl,
              savePaymentMethod: data?.policy?.savePaymentMethod,
              clientType: data?.policy?.clientType,
              description: data?.policy?.description,
              userInfo: {
                accountId: data?.policy?.userInfo?.accountId,
                tokenId: data?.policy?.userInfo.tokenId,
                email: data?.policy?.userInfo?.email,
              },
            });
            break;
          case "P003":
            setDataToSend({
              policy: {
                feeType: data?.policy?.feeType,
                idNumber: data?.policy?.idNumber,
                prdName: data?.policy?.prdName,
                productCode: data?.policy?.productCode,
                phName: data?.policy?.phName,
                ccAllow: data?.policy?.ccAllow,
                orderId: `${data?.policy?.idNumber}_${params?.frSystm}_${data?.policy?.feeType
                }_${new Date().getTime()}`,
                payId: params?.paymentId,
                topup: data?.policy?.topUp,
              },
              callbackUrl: callBackUrl,
              savePaymentMethod: data?.policy?.savePaymentMethod,
              clientType: data?.policy?.clientType,
              description: data?.policy?.description,
              userInfo: {
                accountId: data?.policy?.userInfo?.accountId,
                tokenId: data?.policy?.userInfo.tokenId,
                email: data?.policy?.userInfo?.email,
              },
            });
            break;
          case "P004":
            setDataToSend({
              policy: {
                feeType: data?.policy?.feeType,
                idNumber: data?.policy?.idNumber,
                prdName: data?.policy?.prdName,
                productCode: data?.policy?.productCode,
                phName: data?.policy?.phName,
                ccAllow: data?.policy?.ccAllow,
                orderId: `${data?.policy?.idNumber}_${params?.frSystm}_${data?.policy?.feeType
                }_${new Date().getTime()}`,
                payId: params?.paymentId,
                reInstate: {
                  id: data?.policy?.reInstate?.id,
                  totalAmt: data?.policy?.reInstate?.amount,
                },
              },
              callbackUrl: callBackUrl,
              savePaymentMethod: data?.policy?.savePaymentMethod,
              clientType: data?.policy?.clientType,
              description: data?.policy?.description,
              userInfo: {
                accountId: data?.policy?.userInfo?.accountId,
                tokenId: data?.policy?.userInfo.tokenId,
                email: data?.policy?.userInfo?.email,
              },
            });
            break;
          case "P005":
            setDataToSend({
              policy: {
                feeType: data?.policy?.feeType,
                idNumber: data?.policy?.idNumber,
                prdName: data?.policy?.prdName,
                productCode: data?.policy?.productCode,
                phName: data?.policy?.phName,
                ccAllow: data?.policy?.ccAllow,
                orderId: `${data?.policy?.idNumber}_${params?.frSystm}_${data?.policy?.feeType
                }_${new Date().getTime()}`,
                payId: params?.paymentId,
                addRider: {
                  id: data?.policy?.addRider?.id,
                  totalAmt: data?.policy?.addRider?.amount,
                },
              },
              callbackUrl: callBackUrl,
              savePaymentMethod: data?.policy?.savePaymentMethod,
              clientType: data?.policy?.clientType,
              description: data?.policy?.description,
              userInfo: {
                accountId: data?.policy?.userInfo?.accountId,
                tokenId: data?.policy?.userInfo.tokenId,
                email: data?.policy?.userInfo?.email,
              },
            });
            break;
          case "P006":
            setDataToSend({
              policy: {
                feeType: data?.policy?.feeType,
                idNumber: data?.policy?.idNumber,
                prdName: data?.policy?.prdName,
                productCode: data?.policy?.productCode,
                phName: data?.policy?.phName,
                ccAllow: data?.policy?.ccAllow,
                orderId: `${data?.policy?.idNumber}_${params?.frSystm}_${data?.policy?.feeType
                }_${new Date().getTime()}`,
                payId: params?.paymentId,
                changePaymentFrequency: {
                  id: data?.policy?.changePaymentFrequency?.id,
                  totalAmt: data?.policy?.changePaymentFrequency?.amount,
                },
              },
              callbackUrl: callBackUrl,
              savePaymentMethod: data?.policy?.savePaymentMethod,
              clientType: data?.policy?.clientType,
              description: data?.policy?.description,
              userInfo: {
                accountId: data?.policy?.userInfo?.accountId,
                tokenId: data?.policy?.userInfo.tokenId,
                email: data?.policy?.userInfo?.email,
              },
            });
            break;

          default:
            break;
        }
      } catch (e) {
        const err = e as AxiosError;
        setDataToSend(null);
      } finally {
        setIsLoading(false);
      }
    } else {
      localStorage.removeItem("paymentId");
      localStorage.removeItem("frSystm");
      setIsLoading(false);
    }
  };

  const fetchDataCardToken = (accountId: string) => {
    getTokenCardByAccountId(
      !_.isEmpty(params) ? params.frSystm : FR_HEADER, accountId
    ).then(res => {
      if (res?.data?.msgSts?.code === "200") {
        if (res?.data?.data && res?.data?.data?.banks?.length > 0) {
          setShowCardSaved(true);
          setDataCardToken(res?.data?.data.banks);
        } else {
          setShowCardSaved(false);
          setDataCardToken([]);
        }
      }
    }).catch(err => {

    })
  }

  function openInCurrentTab(url) {
    let win = window.open(url, "_self");
    win.focus();
  }

  const onCreateInitPayment = async (dataForm?: IForm) => {
    const itemTypePaySelect = channels?.find(
      (item) => item?.partner?.partnerCode === watch("typePay")
    );
    const orderIdNew = `${dataToSend?.policy?.idNumber}_${params?.frSystm ? params?.frSystm : FR_HEADER
    }_${dataToSend?.policy?.feeType}_${new Date().getTime()}`;
    const humanFee = watch("type");
    const newDataToSend: IRequestInitPayment = {
      ...dataToSend,
      description: makeDescription(
        dataToSend?.policy?.idNumber,
        itemTypePaySelect.partner.partnerCode,
        itemTypePaySelect.partner.partnerName
      ),
      policy: {
        ...dataToSend.policy,
        orderId:
          watch("typePay") === "QRGEN" &&
          dataRequestInitPayment?.policy?.orderId
            ? dataRequestInitPayment?.policy.orderId
            : orderIdNew,
      },
      userInfo: {
        accountId: dataToSend.userInfo?.accountId,
        tokenId: dataForm?.tokenId ? dataForm?.tokenId : dataToSend.userInfo.tokenId,
        email: !userEmail ? (humanFee === '1' ? dataForm?.user_email : dataForm?.email) : dataToSend.userInfo.email
      }
    };
    if (
      localStorage.getItem("paymentResult") === PaymentResultSuccess &&
      params?.paymentId === localStorage.getItem("paymentedId")
    ) {
      PopupService.instance.current.open({
        visible: true,
        content: "Giao dịch này đã được thanh toán.",
        onOk: () => {
          PopupService.instance.current.close();
          navigate("/");
        },
      });
      setDisabledButton(true);
    } else {
      try {
        setIsLoading(true);
        if (humanFee == "2") {
          await chargePayer(
            {
              policyNumber: newDataToSend?.policy?.idNumber,
              isBuyer: false,
              fullName: dataForm?.name,
              email: dataForm?.email,
              phoneNumber: `${dataForm?.phone}`,
              paymentType: itemTypePaySelect?.partner?.partnerName,
            },
            params?.frSystm
          );
        } else {
          await chargePayer(
            {
              policyNumber: newDataToSend?.policy?.idNumber,
              isBuyer: true,
              paymentType: itemTypePaySelect?.partner?.partnerName,
            },
            params?.frSystm
          );
        }
        const res = await postInitPayment(
          newDataToSend,
          itemTypePaySelect.channel.channelCode,
          itemTypePaySelect.partner.partnerCode
        );
        localStorage.setItem("dataPayment", JSON.stringify(newDataToSend));
        localStorage.setItem("followedFlow", 'true');
        localStorage.setItem(
          "partnerCode",
          itemTypePaySelect.partner.partnerCode
        );

        if (res.data.msgSts.code == "400"
          || res.data.msgSts.code == "500"
          || res.data.msgSts.code == "001"
        ) {
          PopupService.instance.current.open({
            visible: true,
            content:
              res.data.msgSts.message ||
              "Đã có lỗi xảy ra vui lòng thử lại sau",
            onOk: () => {
              PopupService.instance.current.close();
            },
          });
        } else {
          if (watch("typePay") === "QRGEN" || watch("typePay") === "VIETQR") {
            localStorage.setItem("QRCodeData", JSON.stringify(res.data.data));
            localStorage.setItem("vietQRType", watch("typePay"));

            if (isMobile) {
              navigate("/qr-pay");
            } else {
              setOpenQrPayDialog(true);
            }
          } else if (res.data.data.target) {
            handleBackApp('productName', {productName: newDataToSend?.policy?.prdName});
            handleBackApp('dataPayment', { feeType: newDataToSend?.policy?.feeType, policyNum: newDataToSend?.policy?.idNumber });
            openInCurrentTab(res.data.data.target);
          }
        }
      } catch (e) {
        const err = e as AxiosError;
        const message = getErrorMessage(e);
        PopupService.instance?.current?.open({
          visible: true,
          content: message || "Đã có lỗi xảy ra vui lòng thử lại sau",
          onOk: () => {
            PopupService.instance.current.close();
          },
        });
        setIsLoading(false);
      } finally {
        // if (watch("typePay") === "QRGEN" || watch("typePay") === "VIETQR") {
          setIsLoading(false);
        // }
      }
    }
  };
  function getErrorMessage(error: unknown): string {
        const defaultMsg = error.toString() || "Đã có lỗi xảy ra vui lòng thử lại sau";
        if (!error || typeof error !== "object") return defaultMsg;

        const axiosErr = error as AxiosError & { response?: any };
        const data = axiosErr.response?.data;
        const msg =
            data?.msgSts?.message ??
            data?.message ??
            (axiosErr as any).message ??
            defaultMsg;

        return String(msg);
    }



    const onChangeSelect = (value) => {
    if (value == "1") {
      reset({
        ...control._formValues,
        typePay: watch("typePay"),
      });
    }
  };

  useEffect(() => {
    clearInterval(window.interval);
    fetchData();
  }, [history]);

  // window.onpopstate = () => {
  //   PopupService.instance.current.open({
  //     visible: true,
  //     content: "Đã có lỗi xảy ra vui lòng thử lại sau",
  //     onOk: () => {
  //       PopupService.instance.current.close();
  //     },
  //   });
  //   fetchData();
  // };

  useEffect(() => {
    localStorage.setItem("QRCodeData", null);
    clearInterval(window.interval);
    if (!state && !search) {
      navigate("/");
    }
  }, []);

  const checkDisabledFromValue = () => {
    if (watch("type") == "2") {
      if (
        _.isEmpty(watch("name")) ||
        _.isEmpty(watch("email")) ||
        _.isEmpty(watch("phone"))
      ) {
        return true;
      }
      return false;
    }
    if (watch("type") == "1" && !userEmail) {
      if (
        _.isEmpty(watch("user_email"))
      ) {
        return true;
      }
      return false;
    }
    return false;
  };

  const handleBackInfoPay = () => {

    const data = localStorage.getItem('dataInfoPay') ? JSON.parse(localStorage.getItem('dataInfoPay')) : null;
    if (dataRequestInitPayment && dataRequestInitPayment?.policy?.urlBack) {
      window.location.href = dataRequestInitPayment?.policy?.urlBack;
    } else {
      navigate('/infor-pay', {state: data ? {data, frSystm: params?.frSystm} : null});
    }
  }

  const makeDescription = (
    idNumber: string,
    typePay: string,
    typePayName: string
  ) => {
    if (typePay === partnerCode.localCard) {
      return `${idNumber} MBTTND`;
    }
    if (typePay === partnerCode.internationalCard) {
      return `${idNumber} MBTTQT`;
    }
    if (typePay === partnerCode.localCard) {
      return `${idNumber} ${typePayName}`;
    }
  };

  const onDeleteTokenCardById = (id: number) => {
    PopupService.instance.current.open({
      visible: true,
      showIconClose: true,
      content: i18n.t("deleteTokenCard"),
      onOk: () => {
        deleteTokenCardById("", id).then(res => {
          if (res) {
            fetchDataCardToken(userInfo?.accountId);
            PopupService.instance.current.close();
          }
        })
      },
      onCancel: () => {
        PopupService.instance.current.close();
      }
    });
  }

  const onClickCardToken = (item: any) => {
    setTokenSeleted(item?.id);
    setValue("typePay", "baokim");
    let dataForm = watch();
    onCreateInitPayment({...dataForm, typePay: "baokim", tokenId: item?.id});
  }

  return (
    <div>
      {!isMobile && <HeaderTitle>Đóng phí bảo hiểm</HeaderTitle>}
      <StepsPayment step={2} onPressStep={() => {
      }}/>
      <div
        style={{
          backgroundColor: colors.background.white,
          borderRadius: "16px",
        }}
      >
        <ContainerContent className={classes.containerContent}>
          <div className="flex items-center justify-start">
            {/* {FR_SYSTEM_CONFIG_MBAL_APP.includes(params?.frSystm) && params?.type !== 'eform' &&
              // check là eform
          } */}
            <div onClick={() => handleBackInfoPay()} className="pb-5">
              <ArrowBackIosIcon/>
            </div>
            <SesstionTitle>Thông tin người đóng phí</SesstionTitle>
          </div>
          <div className={classes.container}>

            <ControllerRadio
              control={control}
              name={"type"}
              containerStyle={{justifyContent: "space-evenly"}}
              options={[
                {value: 1, label: "Là bên mua bảo hiểm"},
                {
                  value: 2,
                  label: "Khác bên mua bảo hiểm"
                },
              ]}
              onChangeSelect={(value) => onChangeSelect(value)}
              row={!isMobile}
            />


          </div>
          {watch("type") == "1" && !userEmail && (
            <Grid container spacing={2}>
              <Grid item md={4} xs={12}>
                <ControllerTextField
                  control={control}
                  name={"user_email"}
                  title={"Email người đóng phí"}
                  required
                  placeholder={"Nhập Email người đóng phí"}
                  type="text"
                  inputProps={{maxLength: 100}}
                />
              </Grid>
            </Grid>
          )}
          {watch("type") == "2" && (
            <Grid container spacing={2}>
              <Grid item md={4} xs={12}>
                <ControllerTextField
                  control={control}
                  name={"name"}
                  title={"Họ và tên người đóng phí"}
                  required
                  placeholder={"Nhập họ và tên người đóng phí"}
                  type="text"
                  inputProps={{maxLength: 100}}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <ControllerTextField
                  control={control}
                  name={"email"}
                  title={"Email người đóng phí"}
                  required
                  placeholder={"Nhập Email người đóng phí"}
                  type="text"
                  inputProps={{maxLength: 100}}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <ControllerTextField
                  type="number"
                  inputProps={{maxLength: 10}}
                  control={control}
                  name={"phone"}
                  title={"Số điện thoại người đóng phí"}
                  required
                  placeholder={"Nhập số điện thoại người đóng phí"}
                />
              </Grid>
            </Grid>
          )}
        </ContainerContent>
        <ContainerContent className={classes.containerContent}>
          <SesstionTitle>{showCardSaved ? "Phương thức thanh toán đã lưu" : "Phương thức thanh toán"}</SesstionTitle>
          {
            !showCardSaved &&
              <ControllerRadio
                  control={control}
                  name={"typePay"}
                  containerStyle={{justifyContent: "space-between"}}
                  singleSubContentMode={false}
                  contentContainer={
                    !isMobile
                      ? {
                        backgroundColor: colors.background.grayBlur,
                        padding: "10px 20px",
                        width: options?.length < 3 ? "49%" : "32%",
                        marginBottom: "10px",
                        display: "flex",
                        alignItems: "center",
                      }
                      : {
                        background: colors.background.grayBlur,
                        padding: "10px 20px",
                        width: "100%",
                        marginBottom: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                      }
                  }
                  options={options}
                  row
              />
          }
          {
            showCardSaved &&
              <CardToken
                  data={dataCardToken}
                  onDeleteItem={(id) => onDeleteTokenCardById(id)}
                  onClick={(item) => onClickCardToken(item)}
              />
          }

          <div className={`${classes.buttonContainer} flex-col md:flex-row`}>
            <div
              className="mb-2 md:mb-0 md:mr-6 flex justify-center"
            >
              {/* <ButtonCommon
                onEvent={() => handleBackInfoPay()}
                style={{
                  paddingLeft: 90,
                  paddingRight: 90,
                  marginRight: '10px'
                }}
              >
                Quay lại
              </ButtonCommon> */}
            </div>

            <div
              className="flex justify-center"
            >
              {
                !showCardSaved && <ButtonCommon
                      disabled={
                        !watch("typePay") ||
                        !_.isEmpty(formState.errors) ||
                        _.isEmpty(dataToSend) ||
                        checkDisabledFromValue() ||
                        disabledButton
                      }
                      onEvent={handleSubmit(onSubmit)}
                      style={{
                        paddingLeft: 90,
                        paddingRight: 90,
                        marginRight: '10px'
                      }}
                  >
                      Tiếp tục thanh toán
                  </ButtonCommon>
              }
              {
                showCardSaved &&
                  <ButtonCommon
                      onEvent={() => setShowCardSaved(false)}
                  >
                      Phương thức thanh toán khác
                  </ButtonCommon>
              }
            </div>
          </div>
        </ContainerContent>
      </div>
      <div>
        <Dialog
          open={openQrPayDialog}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon/>
          </IconButton>
          <DialogContent>
            <QrPayContent isCheckPayStatus={openQrPayDialog}/>
          </DialogContent>
          <DialogActions>

          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default TypePay;

